import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	viewWorkflow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	viewWorkflow: {
		id: 'issue-field-status.common.view-workflow.button.view-workflow',
		defaultMessage: 'View workflow',
		description: 'Footer action item to view the workflow in the status view dropdown',
	},
});
export default messages;
